import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TESTIMONIALS } from "@/lib/content";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

export default function Testimonials() {
    const [idx, setIdx] = useState(0);
    const next = () => setIdx((i) => (i + 1) % TESTIMONIALS.length);
    const prev = () =>
        setIdx((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
    const t = TESTIMONIALS[idx];

    return (
        <section
            data-testid="testimonials-section"
            className="relative py-24 border-t border-white/5 bg-[#0A0A0B]"
        >
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <Quote
                    size={40}
                    className="text-[#C4A977]/70 mx-auto"
                    strokeWidth={1}
                />
                <AnimatePresence mode="wait">
                    <motion.blockquote
                        key={idx}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.5 }}
                        className="mt-8 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.2] text-[#F4F4F5] italic"
                    >
                        “{t.quote}”
                    </motion.blockquote>
                </AnimatePresence>
                <p
                    data-testid={`testimonial-author-${idx}`}
                    className="mt-10 overline"
                >
                    — {t.author}
                </p>

                <div className="mt-12 flex items-center justify-center gap-4">
                    <button
                        onClick={prev}
                        data-testid="testimonial-prev"
                        aria-label="Föregående"
                        className="w-11 h-11 grid place-items-center border border-white/10 hover:border-[#C4A977] hover:text-[#C4A977] transition-colors"
                    >
                        <ChevronLeft size={16} />
                    </button>
                    <div className="flex gap-2">
                        {TESTIMONIALS.map((_, i) => (
                            <button
                                key={i}
                                onClick={() => setIdx(i)}
                                data-testid={`testimonial-dot-${i}`}
                                aria-label={`Visa citat ${i + 1}`}
                                className={`w-8 h-[2px] transition-colors duration-500 ${
                                    idx === i
                                        ? "bg-[#C4A977]"
                                        : "bg-white/10 hover:bg-white/30"
                                }`}
                            />
                        ))}
                    </div>
                    <button
                        onClick={next}
                        data-testid="testimonial-next"
                        aria-label="Nästa"
                        className="w-11 h-11 grid place-items-center border border-white/10 hover:border-[#C4A977] hover:text-[#C4A977] transition-colors"
                    >
                        <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        </section>
    );
}
